import { memberService } from '../services'

const state = {
    all: {
        loading: false,
        total: 0,
        rows: []
    },
    loading: false
}

const actions = {

    getAll ({ dispatch, commit }, params) {
        commit('getAllRequest')
        memberService.getAll(params).then(
            response => {
                commit('getAllSuccess', response)
            }
        )
    },

    add({ dispatch, commit }, params) {
        commit('startRequest')
        memberService.add(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Member created successfully', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to perform action: ' + error, { root: true })
            }
        )
    },


}

const mutations = {
    getAllRequest (state, params) {
        state.all = { loading: true, total: 0, rows: [] }
    },
    getAllSuccess (state, data) {
        state.all = { loading: false, total: data.total, rows: data.rows }
    },
    startRequest (state) {
        state.loading = true
    },
    endRequest (state) {
        state.loading = false
    },
}

const getters = {
    isLoadingMembers (state) {
        return state.all.loading === true
    },
    getMembersLength (state) {
        return state.all.total
    },
    getMembers (state) {
        return state.all.rows
    },
    isBusy () {
        return state.loading === true
    }
}

export const MEMBER_OPTIONS = {
    membershipLevelOptions: [
        { value: 'member', text: 'Member' },
        { value: 'paid_member', text: 'Paid' },
        { value: 'complimentary', text: 'Complimentary' },
    ],
    membershipLengthOptions: [
        { value: 1, text: '1 Month' },
        { value: 2, text: '2 Month' },
        { value: 3, text: '3 Month' },
        { value: 4, text: '4 Month' },
        { value: 5, text: '5 Month' },
        { value: 6, text: '6 Month' },
        { value: 7, text: '7 Month' },
        { value: 8, text: '8 Month' },
        { value: 9, text: '9 Month' },
        { value: 10, text: '10 Month' },
        { value: 11, text: '11 Month' },
        { value: 12, text: '1 Year' },
        { value: 600, text: 'Lifetime' },
    ],
    membershipTypeOptions: [
        { value: null, text: 'Select Type' },
        { value: 'complimentary', text: 'Complimentary' },
        { value: 'free_trial', text: 'Free Trial' },
        { value: 'paid_paypal', text: 'Paid by PayPal' },
        { value: 'paid_other', text: 'Paid by other' },
        { value: 'other', text: 'Other' },
    ],
}

export const memberModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
